import { z } from "zod";
import { sceneObjectTypeEnumSchema } from "../../enumSchemas";

const sceneObjectDataSchema = z.object({
    uuid: z.string(),
    type: sceneObjectTypeEnumSchema,
    parentId: z.string().nullable().optional(),
    ownedBy: z.string().nullable().optional(),
    modifiedAt: z.string().optional()
  });

export default sceneObjectDataSchema;